import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { AnchorLink } from "gatsby-plugin-anchor-links";

// styles
import * as styles from "./Header.module.css";

const LandingPageHeaderComponent = props => {
  const handleHeaderCtaClick = () => {
    // Mixpanel Event
    props.handleMixpanelCTA(props.ctaText, props.mixpanelCtaLocation);

    // Quiz -> Redirect to Next Step/Screen
    // Ex: Used in metabolism quiz landing page -> /quiz/metabolism-lp
    if (props.quizNextStep) props.handleNextStep(props.quizNextStep);
  };
  return (
    <>
      <div className={`${styles.landingPageHeader}`}>
        <nav
          className={`navbar navbar-expand-lg fixed-top navbar-light ${styles.landingPageNavbar}
          `}
        >
          <div className={`container-fluid ${styles.landingPageLogo}`}>
            <div className="navbar-brand">
              <StaticImage
                src="../../images/twin-logo/Twin_Logo_2024.png"
                alt="Banner"
                placeholder="blurred"
                quality={90}
                className={styles.logoImage}
              />
            </div>
            <div className={styles.landingPageCta}>
              <AnchorLink to={props.ctaRedirectionUrl}>
                <button onClick={handleHeaderCtaClick}>{props.ctaText}</button>
              </AnchorLink>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default LandingPageHeaderComponent;
